<template>
  <div>
    <div class="shadow" :data-active="active" @click="active = false" />
    <div id="sidebar" :data-active="active" v-bind:style="{ background: `url('${AboutImage}') left top no-repeat white` }">
      <div class="header">
        <div class="heading-text">
          SOBRE O TRILHAS
        </div>
        <div class="close-button">
          <img :src="X" alt="fechar" @click="active = false">
        </div>
      </div>
      <div class="content">
        <div class="title">
          Bem-vindo ao trilhas!
        </div>
        <div class="paragraph">
          Neste programa você poderá navegar por todas posições existentes na FTD Educação e compreender suas correlações. Navegue e encontre o seu cargo distribuído entre as diretorias e saiba as trilhas possíveis para sua carreira.          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import AboutImage from 'Assets/images/about-image.jpg';
  import X from 'Assets/images/x.svg';

  export default {
    props: {},
    data() {
      return {
        X,
        AboutImage,
        active: false,
      };
    },

    // Lifecyle
    created() {
      EventSystem.$on('about-open', () => {
        this.active = true;
      });

      EventSystem.$on('keypress-esc', () => {
        this.active = false;
      });
    },
    // Methods
    computed: {},
    methods: {},
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/sidebar.vue